var exports = {
  "k": "xa15a2ab7--df6d68--container",
  "F": "xa15a2ab7--df6d68--no-media",
};

module.exports = exports;
